import { motion } from 'framer-motion';
import ImageAdaptive from '@/components/ImageAdaptive';

export default function Loading({ topClass = '' }) {
    return (
        <div className="flex flex-col justify-center items-center">
            <motion.div key="loading" className={`absolute inset-0 flex justify-center items-center ${topClass}`}>
                <ImageAdaptive src="/images/common/loading.svg" baseWidth={80} breakpoints={{ md: 100 }} />
            </motion.div>
        </div>
    );
}
